





























import Vue from "vue";
import { PPBookings } from "@/picking-portal/models/PPBookings";
import PPSlotBookingsItem from "@/picking-portal/components/PPSlotBookingsItem.vue";
import { storeService } from "@/common/services/StoreService";
import { bookingService } from "@/picking-portal/services/PPBookingService";
import { DateTime } from "luxon";
import PPCollectOrderScanner from "@/picking-portal/components/PPCollectOrderScanner.vue";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";

export default Vue.extend({
  name: "PPSlotBookings",
  components: {
    PPCollectOrderScanner,
    PPSlotBookingsItem,
  },
  props: {
    storeId: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bookings: null as PPBookings[] | null,
      isLoading: true as boolean,
      storeService,
    };
  },
  computed: {
    breadcrumbs(): Array<Record<string, string | boolean>> {
      return this.$route?.meta?.breadCrumb({
        storeId: storeService.selectedStore,
        date: DateTime.now().toSQLDate(),
      });
    },
    currentStore: function (): string {
      return this.storeService.selectedStore;
    },
  },
  watch: {
    currentStore: function (): void {
      this.changeStore();
    },
  },
  async beforeMount() {
    this.storeService.selectedStore = this.storeId;
    await this.loadBookings();
  },
  methods: {
    async loadBookings(): Promise<void> {
      this.isLoading = true;
      const currentStore = this.storeService.stores.find((store) => store.id === this.storeService.selectedStore);
      if (currentStore && currentStore.clickAndCollectEnabled) {
        this.bookings = await bookingService.getBookingsByDate(currentStore.id, DateTime.fromISO(this.date));
      } else {
        this.bookings = null;
      }
      this.isLoading = false;
    },
    async changeStore(): Promise<void> {
      try {
        await this.$router
          .push({
            name: RouteInfoMap.get(Paths.ClickAndCollect)?.name,
            query: {
              storeId: storeService.selectedStore.toString(),
              date: DateTime.now().toFormat("yyyy-MM-dd"),
            },
          })
          .catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        // eslint-disable-next-line no-empty
      } catch (error) {}
      await this.loadBookings();
    },
    getEmptyText(): string {
      if (this.bookings == null) {
        return this.$t("modules.packing-portal.pages.slot-booking.click-and-collect-not-enabled").toString();
      } else {
        return this.$t("modules.packing-portal.pages.slot-booking.no-bookings").toString();
      }
    },
  },
});
